import { Badge } from '@ipfabric/ui-components/Badge/Badge';
import type React from 'react';

export const ARRAY_CELL_MAX_ITEMS = 50;

export const maybeWrapWithMore =
  (cellData: unknown[]) => (trimmedContent: React.ReactNode) => {
    if (cellData.length <= ARRAY_CELL_MAX_ITEMS) {
      return trimmedContent;
    }

    return (
      <>
        {trimmedContent}{' '}
        <Badge color='neutral'>
          + {cellData.length - ARRAY_CELL_MAX_ITEMS} more
        </Badge>
      </>
    );
  };
